import React from "react";
import { TitleL } from "components/Typography";
import {
  Container,
  Wrapper,
  TitleWrapper,
  ItemsWrapper,
  Item,
  Number,
  ItemTitle,
  StyledList,
  StyledListItem,
  ListWrapper,
} from "./styles";
import uuid from "react-uuid";

export const OurProcess = ({ data }) => {
  return (
    <Container>
      <Wrapper>
        <TitleWrapper>
          <TitleL underline>{data.title}</TitleL>
        </TitleWrapper>
        <ItemsWrapper>
          {data.steps.map((item, i) => (
            <Item key={uuid()}>
              <Number>{`.0${i + 1}`}</Number>
              <ListWrapper>
                <ItemTitle>{item.title}</ItemTitle>
                <StyledList>
                  {item.list.map((list_item) => (
                    <StyledListItem key={uuid()}>{list_item}</StyledListItem>
                  ))}
                </StyledList>
              </ListWrapper>
            </Item>
          ))}
        </ItemsWrapper>
      </Wrapper>
    </Container>
  );
};
